import { mapTime } from 'components/Shared/Product/selector';
import { ProductDetailedMeta } from 'models/ProductMeta';
import { rm } from 'utils';
import { hasRentalPriceSelector } from 'components/Shared/Price/selector';
import { useSelector } from 'react-redux';

interface Props {
  meta: ProductDetailedMeta;
  showDeliveryInfo: boolean;
}

export const DeliveryEstimate = ({ showDeliveryInfo, meta }: Props): JSX.Element | null => {
  const isRentalProduct = useSelector(hasRentalPriceSelector);

  if (!showDeliveryInfo || isRentalProduct) {
    return null;
  }

  const deliveryEstimate = getDeliveryEstimate({ meta });

  return <>{deliveryEstimate}</>;
};

const getDeliveryEstimate = ({ meta }: Pick<Props, 'meta'>) => {
  return (
    <>
      &nbsp;-&nbsp;
      {meta.deliveryEstimate === 0
        ? rm('delivery_time_unknown')
        : rm('deliverystatus_resultstring_normal', mapTime(meta.deliveryEstimate))}
    </>
  );
};
